import React from 'react';
import {
  Box,
  Grid,
  HStack,
  Skeleton,
  Stat,
  StatLabel,
  StatNumber,
} from '@chakra-ui/react';
import { FiClipboard, FiMap, FiUser } from 'react-icons/fi';
import { SaktiRkhKpiData } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiRkhKpiCardsProps {
  loading: boolean;
  data: SaktiRkhKpiData;
}

const formatNumber = (value: number) => {
  return value.toLocaleString('id-ID');
};

const SaktiRkhKpiCards: React.FC<SaktiRkhKpiCardsProps> = ({ loading, data }) => {
  const cards = [
    {
      key: 'total-rkh',
      label: 'TOTAL RKH',
      value: formatNumber(data.total_rkh),
      icon: FiClipboard,
    },
    {
      key: 'total-harvesters',
      label: 'TOTAL PEMANEN',
      value: formatNumber(data.total_harvesters_fp_required),
      icon: FiUser,
    },
    {
      key: 'total-area',
      label: 'LUASAN PANEN (HA)',
      value: formatNumber(data.total_harvest_area),
      icon: FiMap,
    },
  ];

  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={3}>
      {cards.map((card) => (
        <Skeleton key={card.key} isLoaded={!loading} borderRadius={SAKTI_UI_SIZE.cardRadius}>
          <Box
            borderWidth="1px"
            borderColor="gray.200"
            borderRadius={SAKTI_UI_SIZE.cardRadius}
            p={SAKTI_UI_SIZE.cardPadding}
            bg="white"
          >
            <HStack justify="space-between" align="center">
              <Stat>
                <StatLabel
                  color="gray.500"
                  letterSpacing="wider"
                  fontSize={SAKTI_UI_SIZE.kpiLabel}
                >
                  {card.label}
                </StatLabel>
                <StatNumber fontSize={SAKTI_UI_SIZE.kpiValue}>{card.value}</StatNumber>
              </Stat>
              <Box as={card.icon} color="customGreen.500" boxSize={SAKTI_UI_SIZE.kpiIconBoxSize} />
            </HStack>
          </Box>
        </Skeleton>
      ))}
    </Grid>
  );
};

export default SaktiRkhKpiCards;
